import { createContext } from "react";
import type { LoaderType } from "./loading.service";

interface LoadingContextType {
  isLoading: boolean;
  loaderType: LoaderType;
  inlineLoadingElement: string | null;
  setLoading: (loading: boolean, loaderType?: LoaderType, elementId?: string) => void;
}

export const LoadingContext = createContext<LoadingContextType | undefined>(undefined);
